<template>
   <div class="modal" v-show="show">
    <div class="modal-wrapper">
      <div class="modal-container" style="max-width: 720px">
            <div class="modal-header">Actualizar</div>
            <div class="modal-body" >
                <div class="form">
                    
                    <div class="group">
                        <div class="form-input">
                            <vs-input label="Número de tracking" v-model.trim="inventory.tracking"/>
                        </div>
                        
                        <div :class="['form-input',{'has-error': $v.inventory.customer.$error }]">
                            <label for="">Cliente:</label>
                            <select-input :options="customers" v-model="$v.inventory.customer.$model"></select-input>
                            <span class="error-text" v-if="$v.inventory.customer.$error"><feather type="info" />Este campo es requerido</span>
                        </div>

                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': $v.inventory.product.$error }]">
                            <label class="vs-input--label">Producto <small class="needPermission" v-if="inventory.product.permission == 1">(requiere permiso)</small></label>
                            <select-input :options="products" v-model="$v.inventory.product.$model"></select-input>
                            <span class="error-text" v-if="$v.inventory.product.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input',{'has-error': $v.inventory.weight.$error }]">
                            <vs-input label="Peso (lb)" v-model.trim="$v.inventory.weight.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="$v.inventory.weight.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': $v.inventory.inv02Code.$error }]">
                            <vs-select autocomplete label="Ubicación:" v-model="$v.inventory.inv02Code.$model">
                                <vs-select-item :key="index" :value="item.code" :text="item.code" v-for="(item,index) in locations" />
                            </vs-select>
                            <span class="error-text" v-if="$v.inventory.inv02Code.$error"><feather type="info" />Este campo es requerido</span>
                        </div>

                        <div :class="['form-input']">
                            <vs-input label="Proveedor" v-model.trim="inventory.provider"/>
                        </div>
                    </div>
                    <div :class="['form-input']">
                        <vs-input label="Comentarios" v-model.trim="inventory.comments"/>
                    </div>           
                </div>
            </div>
            <div class="modal-footer">
                <vs-button color="danger" type="border" icon="block" @click="closeModal()">No, Cancelar</vs-button>
                <vs-button  :disabled="confirmStatus" id="btnConfirm" color="success" @click="updatePackageStatus()" type="border" icon="check" class="vs-con-loading__container">Si, Actualizar</vs-button>
            </div>  
      </div>
    </div>
  </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import SelectInput from '@/components/Form/Select-Input.vue'
import InventoryModel from "@/models/InventoryModel"
import { required } from 'vuelidate/lib/validators' 
import InventoryService from "@/services/InventoryService"
import ClientDataService from "@/services/ClientDataService"
import TaxDataService from "@/services/TaxDataService"
export default {
  name: 'ModalPackageStatus',
  mixins: [helper],
  components:{
    SelectInput
  },
  props: {
    show: { type: Boolean, required: true },
    // packIDs: { type: Array, default: () => [] },
    inv: { type: Object, default: () => {} },
    modeUdpdate: { type: Boolean, default: true },
  },
  data() {
    return {
        active: false,
        newStatus: this.selected,
        packageId: this.packID,
        confirmStatus: false,
        notify: false,
        status: [],
        inventory: new InventoryModel(),
        locations: [],
        customers: [],
        products: []
        
    }
  },
  validations: {
    inventory: {
        customer: { required },
        inv02Code: { required },
		weight:       { required },
		product:      { required }, 
    }
  },
  mounted(){
    this.retrieveCustomers()
    this.getLocations()
    this.retrieveTaxes()
  },
  watch: {
    inv () {
      this.inventory = this.inv
      this.inventory.customer.name = this.inventory.customer.firstName +" "+ this.inventory.customer.lastName
    }
  },
  methods: {

    retrieveTaxes() {
        TaxDataService.getAll()
        .then(response => {
            this.products = response.data;
        })
        .catch(e => {
            console.log(e);
            this.$vs.notify({title:'Error!',text:'Error obteniendo los productos',color:'danger',icon:'error_outline'})
        });
    },
    getLocations() {
        InventoryService.getLocations()
        .then(response => {
            this.locations =  response.data.records
        })
        .catch(e => {
            console.log(e);
            this.$vs.notify({title:'Error!',text:'Error obteniendo las ubicaciones',color:'danger',icon:'error_outline'})
        });
    },
    retrieveCustomers() {
        ClientDataService.getAll()
        .then(response => {
            response.data.forEach(element => {
                this.customers.push({
                    id: element.id, 
                    name: element.fullName,
                    email: element.email,
                    customerType: element.typecode
                })
            });
            // this.customer = this.customers[0]
            this.customers.push({id: 0, name: "SIN DEFINIR"})

        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los clientes!',color:'danger',icon:'error_outline'})
        });
    },
    closeModal () {
       this.$emit('modal-event', { status: "closed", active: false})
    },
    confirmButton() {
        // console.log(2/222);
      this.$emit('confirm-modal', this.selected, true)
    },
    updatePackageStatus() {
     const that = this
      that.loadingProgress ('#btnConfirm')
      that.confirmStatus = true
      InventoryService.updateInventory(this.inventory.id, {...this.inventory, product: this.inventory.product.code})
      .then(response => {
          console.log(response)
          that.confirmStatus = false
           that.$vs.loading.close('#btnConfirm .con-vs-loading')
           that.$emit('modal-event', { message: response, status:"confirmed", response: this.newStatus, error: false, active: false})
      })
      .catch(e => {
          console.log(e)
          that.confirmStatus = false
          that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          that.$emit('modal-event', { message: e, status:"confirmed", error: true, active: false})
      });
    },
  }
}
</script>
